const { getElement } = window.BAO.utils

const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  static get elements () {
    return {
      link: '[data-product-photoswipe-el="link"]',
    }
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 1,
      maxZoomLevel: 1.5,
      scaleMode: 'zoom',
      gallery: this.shadowRoot ? this.shadowRoot : this,
      children:
        this.els?.link?.selector || '[data-product-photoswipe-el="link"]',
      bgOpacity: 1,
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()

    this.els.link.elements.forEach((el, index) => {
      el.addEventListener('click', event => {
        event.preventDefault()

        const items = this.els.link.elements.map(element => {
          const isVideo = element.dataset.type === 'video'
          const thumb = element.dataset.thumbImage || ''

          if (isVideo) {
            return {
              html: `<div class="pswp__video-wrapper">
                      <video autoplay loop playsinline muted>
                        <source src="${
                          element.querySelector('source[type="video/mp4"]').src
                        }" type="video/mp4">
                      </video>
                    </div>`,
              width: element.dataset.pswpWidth,
              height: element.dataset.pswpHeight,
              thumb,
            }
          } else {
            return {
              src: element.getAttribute('href'),
              width: parseInt(element.dataset.pswpWidth, 10),
              height: parseInt(element.dataset.pswpHeight, 10),
              thumb,
            }
          }
        })

        this.photoSwipeInstance.loadAndOpen(index, items)
      })
    })
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
      this.addPreviousButton()
      this.addNextButton()

      this.photoSwipeInstance.pswp.ui.registerElement({
        name: 'zoom-slider',
        order: 10,
        isButton: false,
        appendTo: 'root',
        html: `<div class="pswp-zoom-slider-wrapper">
                <button class="pswp-zoom-slider-down" data-pswp-el="zoom-out" title="Zoom Out" type="button">
                  <svg viewBox="0 0 9 1" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <rect width="9" height="1" fill="currentColor"></rect>
                  </svg>
                </button>
                <input type="range" min="0" max="4" step="0.1" value="1" class="pswp-zoom-slider">
                <button class="pswp-zoom-slider-up" data-pswp-el="zoom-in" title="Zoom In" type="button">
                  <svg viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <rect y="4" width="9" height="1" fill="currentColor"></rect>
                    <rect x="5" width="9" height="1" transform="rotate(90 5 0)" fill="currentColor"></rect>
                  </svg>
                </button>
              </div>`,

        onInit: (el, pswp) => {
          const slider = el.querySelector('.pswp-zoom-slider')

          const updateSlider = () => {
            const slide = pswp.currSlide
            const content = slide?.content

            const canZoom =
              slide && typeof slide.isZoomable === 'function'
                ? slide.isZoomable()
                : false

            const videoEl = slide?.container?.querySelector('video')
            if (videoEl) {
              videoEl.muted = true
              videoEl.playsInline = true
              videoEl.autoplay = true

              setTimeout(() => {
                videoEl.play().catch(err => {
                  console.warn('Autoplay failed:', err)
                })
              }, 50)
            }

            if (!canZoom) {
              el.style.display = 'none'
              return
            }

            const zoomLevel =
              pswp.currSlide.currZoomLevel || content?.scale || 1
            const minZoomLevel = slide.zoomLevels.min
            const maxZoomLevel = slide.zoomLevels.max

            el.style.display = 'block'
            slider.min = minZoomLevel
            slider.max = maxZoomLevel
            slider.value = zoomLevel.toFixed(2)
          }

          const updateZoom = () => {
            const zoom = parseFloat(slider.value)
            const slide = pswp.currSlide
            if (slide?.content?.isZoomable) {
              pswp.zoomTo(
                zoom,
                {
                  x: pswp.viewportSize.x / 2,
                  y: pswp.viewportSize.y / 2,
                },
                0,
              )
            }
          }

          pswp.on('zoomPanUpdate', updateSlider)
          pswp.on('change', updateSlider)
          pswp.on('contentResize', updateSlider)

          slider.addEventListener('input', () => {
            updateZoom()
          })

          el.addEventListener(
            'touchstart',
            e => {
              e.stopPropagation()
            },
            { passive: true },
          )

          el.addEventListener(
            'touchmove',
            e => {
              e.stopPropagation()
            },
            { passive: true },
          )

          el.addEventListener(
            'click',
            e => {
              e.stopPropagation()
            },
            { passive: true },
          )

          const zoomOut = el.querySelector('[data-pswp-el="zoom-out"]')
          zoomOut.addEventListener('click', () => {
            slider.value = slider.value * 1 - 0.5
            updateZoom()
          })

          const zoomIn = el.querySelector('[data-pswp-el="zoom-in"]')
          zoomIn.addEventListener('click', () => {
            slider.value = slider.value * 1 + 0.5
            updateZoom()
          })
        },
      })
    })

    this.photoSwipeInstance.on('change', () => {
      this.handleSlideChange()
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className:
        'pswp-Action_Arrow pswp-Action_ArrowCustom pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      appendTo: 'wrapper',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className:
        'pswp-Action_Arrow pswp-Action_ArrowCustom pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      appendTo: 'wrapper',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'root',
      onInit: (element, pswp) => {
        const dotEls = []
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = event => {
            pswp.goTo(dotEls.findIndex(btn => btn.contains(event.target)))
          }

          const linkEl = this.els.link.elements[i]

          if (linkEl.dataset.type === 'video') {
            const videoEl = document.createElement('video')
            videoEl.className = 'pswp-Action_DotVideo'
            videoEl.src = linkEl.querySelector('source[type="video/mp4"]').src
            videoEl.muted = true
            videoEl.loop = true
            videoEl.playsInline = true
            videoEl.autoplay = true
            dotEl.appendChild(videoEl)
          } else {
            const imgEl = document.createElement('img')
            imgEl.className = 'pswp-Action_DotImage'
            imgEl.src = linkEl.dataset.thumbImage
            dotEl.appendChild(imgEl)
          }

          element.appendChild(dotEl)

          dotEls.push(dotEl)
        }

        element.addEventListener(
          'touchstart',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        element.addEventListener(
          'touchmove',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        element.addEventListener(
          'wheel',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          dotEls[pswp.currIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          })
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  handleSlideChange () {
    const { pswp } = this.photoSwipeInstance
    const previousEl = getElement('.pswp-Action_Arrow-previous')
    const nextEl = getElement('.pswp-Action_Arrow-next')

    if (pswp && previousEl) {
      previousEl.disabled = pswp.currIndex === 0
    }

    if (pswp && nextEl) {
      nextEl.disabled = pswp.currIndex + 1 === pswp.getNumItems()
    }
  }

  get arrowSvg () {
    return '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="transform: rotate(-90deg);"><rect x="9.19238" width="0.5" height="6.5" transform="rotate(45 9.19238 0)" fill="currentColor"></rect><rect x="0.707031" width="6.5" height="0.5" transform="rotate(45 0.707031 0)" fill="currentColor"></rect></svg>'
  }

  get closeSvg () {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M15.789 16.498 1.646 2.355l.708-.707 14.142 14.143-.707.707Z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M16.496 2.354 2.354 16.496l-.708-.707L15.79 1.647l.707.707Z" clip-rule="evenodd"/></svg>'
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
